module.exports = __webpack_public_path__ + "img/js.f2bd0c0c.svg";